<div class="form-page">
  <div class="form-header">
    <button mat-icon-button (click)="cancel()" aria-label="Back">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h3>Create Production Transfer</h3>
      <div class="muted">
        Reassign one or more in-progress jobs from one employee to another.
      </div>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" class="form-body" *ngIf="isAdmin">
    <div class="row">
      <mat-form-field appearance="outline" class="col-half">
        <mat-label>From Employee</mat-label>
        <mat-select
          #from_employee_id
          (openedChange)="onFromEmployeeScroll($event)"
          [(value)]="selectedFromEmployee"
          (selectionChange)="onFromEmployeeChange($event.value)">
          <input class="select-input" placeholder="Search..." type="text" autocomplete="nope"
                 (keydown)="$event.stopPropagation()" (keyup)="onFromEmployeeKey($event)"
                 matInput name="from_employee_search">
          <mat-option *ngFor="let e of allFromEmployees" [value]="e.id">
            {{ e.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('from_employee_id')?.hasError('required')">
          Source employee is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-half">
        <mat-label>To Employee</mat-label>
        <mat-select
          #to_employee_id
          (openedChange)="onToEmployeeScroll($event)"
          [(value)]="selectedToEmployee"
          (selectionChange)="onToEmployeeChange($event.value)">
          <input class="select-input" placeholder="Search..." type="text" autocomplete="nope"
                 (keydown)="$event.stopPropagation()" (keyup)="onToEmployeeKey($event)"
                 matInput name="to_employee_search">
          <mat-option *ngFor="let e of toEmployeeOptions()" [value]="e.id">
            {{ e.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('to_employee_id')?.hasError('required')">
          Target employee is required
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full">
      <mat-label>His Jobs IN (select one or more)</mat-label>
      <mat-select formControlName="job_ids" multiple>
        <mat-option *ngFor="let j of inHandJobs" [value]="j.job_id">
          {{ j.job_no }} — {{ j.patient_name }} ({{ j.process_name }})
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="loadingJobs">Loading jobs…</mat-hint>
      <mat-hint *ngIf="!loadingJobs && form.value.from_employee_id && inHandJobs.length === 0">
        This employee has no in-progress jobs
      </mat-hint>
      <mat-error *ngIf="form.get('job_ids')?.hasError('required')">
        Select at least one job
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Transfer Reason</mat-label>
      <textarea
        matInput
        formControlName="transfer_reason"
        rows="3"
        maxlength="1000"
        placeholder="Why is this case being transferred?"></textarea>
      <mat-hint align="end">{{ form.value.transfer_reason?.length || 0 }} / 1000</mat-hint>
      <mat-error *ngIf="form.get('transfer_reason')?.hasError('required')">
        Reason is required
      </mat-error>
    </mat-form-field>

    <div class="actions">
      <button mat-stroked-button type="button" (click)="cancel()" [disabled]="submitting">
        Cancel
      </button>
      <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
        <mat-icon>swap_horiz</mat-icon>
        {{ submitting ? 'Transferring…' : 'Transfer' }}
      </button>
    </div>
  </form>
</div>
